import React from 'react';
import { authRoles } from 'app/auth';

export const WorkshopDashboardConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: [...authRoles.participant],
	routes: [
		{
			path: '/workshop-dashboard',
			component: React.lazy(() => import('./WorkshopDashboard'))
		}
	]
};
